let startTime = undefined;
const onBlur = (callback) => {
    if (startTime === undefined)
        return;
    callback({ duration: Math.round(performance.now() - startTime) });
    startTime = undefined;
};
const onFocus = () => {
    if (startTime)
        return;
    startTime = performance.now();
};
const onSessionPaused = (callback) => {
    onFocus();
    const onVisibilityChange = () => {
        if (document.visibilityState === "hidden") {
            onBlur(callback);
        }
        else {
            onFocus();
        }
    };
    document.addEventListener("visibilitychange", onVisibilityChange);
    window.addEventListener("focus", onFocus);
    window.addEventListener("blur", () => onBlur(callback));
};

export { onSessionPaused };
//# sourceMappingURL=onSessionPaused.js.map
